import { Inversify } from '@/src/shared/utils/Inversify';

import type { IClientEnvVars } from '../interfaces/client-env-vars.types';

/*
 *  /api starting paths refer to pages/api proxy routes
 */
@Inversify.injectable('instance')
export default class ClientEnvVars implements IClientEnvVars {
  clientUrl = process.env.NEXT_PUBLIC_CLIENT_URL;
  apiUrl = `${process.env.NEXT_PUBLIC_API_URL}${this.isProduction ? '' : '/api/rest'}`;
  isSentryEnabled = Boolean(process.env.NEXT_PUBLIC_SENTRY_ENABLED);

  get isProduction() {
    return process.env.NODE_ENV === 'production';
  }
}
